import { render, staticRenderFns } from "./FacetTagMenuItem.vue?vue&type=template&id=102cd240&"
import script from "./FacetTagMenuItem.vue?vue&type=script&lang=js&"
export * from "./FacetTagMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports